import React from 'react';

import { FormattedMessage } from 'react-intl';

import { renderFormBasedOnType } from '../../../../../services/filtering/filter-form-render-service';
import { OptionFormTypes } from '../../../../../services/filtering/filter-form-render-service/option-form-types';
import messages from './messages';

export default {
  id: 'city',
  displayName: <FormattedMessage {...messages.city} />,
  type: OptionFormTypes.TYPE_STRING,
  filterValue: 'City',
  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_STRING, criteriaInformations);
  },
};
